
// retry-ensure-webpack-plugin {
var _WebpackRetry_originalEnsure = __webpack_require__.e;
var _WebpackRetry_pendingPromises = Object.create(null);
function _WebpackRetry_tryLoad(chunkId, retriedTimes) {
    return (_WebpackRetry_originalEnsure(chunkId)
        .catch(function () {
        return new Promise(function (resolve) {
            var retry = function () {
                // Clean up. No-op if the listener is not set
                window.removeEventListener('online', retry, false);
                if (navigator.onLine === false) {
                    // If navigator.onLine is supported, and is offline, wait for online
                    window.addEventListener('online', retry, false);
                }
                else if (retriedTimes < 2) {
                    // Retry with a catch
                    resolve(_WebpackRetry_tryLoad(chunkId, retriedTimes + 1));
                }
                else {
                    // Last try: Use the original ensure function
                    resolve(_WebpackRetry_originalEnsure(chunkId));
                }
            };
            setTimeout(retry, retriedTimes * retriedTimes * 1000);
        });
    }));
}
__webpack_require__.e = function (chunkId) {
    if (!_WebpackRetry_pendingPromises[chunkId]) {
        _WebpackRetry_pendingPromises[chunkId] = _WebpackRetry_tryLoad(chunkId, 0);
        var cleanup = function () {
            delete _WebpackRetry_pendingPromises[chunkId];
        };
        _WebpackRetry_pendingPromises[chunkId].then(cleanup, cleanup);
    }
    return _WebpackRetry_pendingPromises[chunkId];
};
// } retry-ensure-webpack-plugin
